const DragDotIco = () => {
    return (
        <svg
            width="4"
            height="7"
            viewBox="0 0 4 7"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M0.666667 1.33333C1.03486 1.33333 1.33333 1.03486 1.33333 0.666667C1.33333 0.298477 1.03486 0 0.666667 0C0.298477 0 0 0.298477 0 0.666667C0 1.03486 0.298477 1.33333 0.666667 1.33333Z"
                fill="black"
                fill-opacity="0.6"
            />
            <path
                d="M0.666667 6.66671C1.03486 6.66671 1.33333 6.36823 1.33333 6.00004C1.33333 5.63185 1.03486 5.33337 0.666667 5.33337C0.298477 5.33337 0 5.63185 0 6.00004C0 6.36823 0.298477 6.66671 0.666667 6.66671Z"
                fill="black"
                fill-opacity="0.6"
            />
            <path
                d="M3.33334 1.33333C3.70153 1.33333 4.00001 1.03486 4.00001 0.666667C4.00001 0.298477 3.70153 0 3.33334 0C2.96515 0 2.66667 0.298477 2.66667 0.666667C2.66667 1.03486 2.96515 1.33333 3.33334 1.33333Z"
                fill="black"
                fill-opacity="0.6"
            />
            <path
                d="M3.33334 6.66671C3.70153 6.66671 4.00001 6.36823 4.00001 6.00004C4.00001 5.63185 3.70153 5.33337 3.33334 5.33337C2.96515 5.33337 2.66667 5.63185 2.66667 6.00004C2.66667 6.36823 2.96515 6.66671 3.33334 6.66671Z"
                fill="black"
                fill-opacity="0.6"
            />
            <path
                d="M3.33334 3.99996C3.70153 3.99996 4.00001 3.70148 4.00001 3.33329C4.00001 2.9651 3.70153 2.66663 3.33334 2.66663C2.96515 2.66663 2.66667 2.9651 2.66667 3.33329C2.66667 3.70148 2.96515 3.99996 3.33334 3.99996Z"
                fill="black"
                fill-opacity="0.6"
            />
            <path
                d="M0.666667 3.99996C1.03486 3.99996 1.33333 3.70148 1.33333 3.33329C1.33333 2.9651 1.03486 2.66663 0.666667 2.66663C0.298477 2.66663 0 2.9651 0 3.33329C0 3.70148 0.298477 3.99996 0.666667 3.99996Z"
                fill="black"
                fill-opacity="0.6"
            />
        </svg>
    );
}


export default DragDotIco;
